export default {
  loading: false,
  users: [],
  admin: {},
  message: null,
}
